import { IRequestAuthorize } from '../../../actions/userAccount/authorize/authorize'
import { IUserAccountStore } from '../index'

export default function(
  state: IUserAccountStore,
  action: IRequestAuthorize,
): IUserAccountStore {
  return {
    ...state,
    credentials: {
      ...state.credentials,
      username: action.username,
    },
    isAuthorizing: true,
  }
}
